// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qNG1","col":"styles_col__1SBZ1"};